<template>
  <v-card class="pa-3 mb-2" outlined :color="borderColor">
    <div class="d-flex flex-row">
      <v-text-field
        v-model="node.name"
        :label="node.type === 'group' ? 'Group Name' : 'Unit Name'"
        dense
        outlined
        hide-details
      />
      <dots-menu :menu-items="menuItems" />
    </div>

    <div v-if="node.type === 'group'" class="ml-4 mt-2">
      <tree-node
        v-for="(child, cIndex) in node.children"
        :key="cIndex"
        :node="child"
        :parent="node.children"
        :index="cIndex"
      />
    </div>
  </v-card>
</template>

<script>
import DotsMenu from '../../menu/DotsMenu.vue'

export default {
  name: 'TreeNode',
  components: {
    DotsMenu
  },
  props: ['node', 'parent', 'index'],
  computed: {
    borderColor() {
      return this.node.type === 'group' ? '' : 'grey lighten-4'
    },
    menuItems() {
      if (this.node.type === 'unit') {
        return [
          {
            title: `Remove ${this.node.name}`,
            icon: 'mdi-delete',
            action: this.removeNode,
            message: 'Removes this unit'
          }
        ]
      } else {
        return [
          {
            title: `Add a unit to ${this.node.name}`,
            icon: 'mdi-plus-box-outline',
            action: this.addUnit,
            message: 'Adds a new unit as a child of this group'
          },
          {
            title: `Add a group to ${this.node.name}`,
            icon: 'mdi-plus-box-outline',
            action: this.addGroup,
            message: 'Adds a new group as a child of this group'
          },
          {
            title: `Remove ${this.node.name}`,
            icon: 'mdi-delete',
            action: this.removeNode,
            message: 'Removes this group'
          }
        ]
      }
    }
  },
  methods: {
    removeNode() {
      this.parent.splice(this.index, 1)
    },
    addGroup() {
      if (!this.node.children) this.$set(this.node, 'children', [])
      this.node.children.push({
        type: 'group',
        name: 'Group ' + (this.node.children.length + 1),
        children: []
      })
    },
    addUnit() {
      if (!this.node.children) this.$set(this.node, 'children', [])
      this.node.children.push({
        type: 'unit',
        name: 'Unit ' + (this.node.children.length + 1)
      })
    }
  }
}
</script>
